export const card = {
    card_full: {
        height: '90vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
    },
	card_long:{
        height: '67.5vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
	},
	card_2_3rd:{
		height: '60vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
	},
	card_mid:{
		height: '45vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
	},
	card_1_3rd:{
		height: '30vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
	},
	card_short:{
		height: '22.5vh',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
	},
	card_very_short:{
        minHeight: 100,
		height: '15vh',
        //padding:"16px 16px 16px 16px"
	},

    card_fit_content:{
        height: 'fit-content',
        overflowY: "auto",
        //padding:"16px 16px 16px 16px"
    },
	cardAction: {
        width: "100%",
        height: "100%"
    },


    content: {
        //ventically center the div
        padding: '16px 16px 0px 16px',
    },
}


// WEBPACK FOOTER //
// ./src/components/CSS/card.js